<div nxLayout="grid">
    <div nxRow>
        <div nxCol="10">
            <button (click)="toggleModal()" nxButton="tertiary" type="button" class="fright">Add Policy</button>
        </div>

    </div>
    <div nxRow>
        <div nxCol="10" colOffset="1">
            <table nxTable zebra>
                <thead>
                    <tr nxTableRow>
                        <th nxHeaderCell>
                            Policy Name
                        </th>
                        <th nxHeaderCell>
                            Duration of Policy
                        </th>
                        <th nxHeaderCell>
                            Amount
                        </th>

                        <th nxHeaderCell>
                            Status
                        </th>
                        <th nxHeaderCell>
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr nxTableRow *ngFor="let item of planMasterList">
                        <td nxTableCell>{{item.planName}}</td>
                        <td nxTableCell>{{item.durationOfPlan}}</td>
                        <td nxTableCell>{{item.totalPrice}}</td>
                        <td nxTableCell *ngIf="item.isActive =='1' else inActive">
                            <nx-badge vibrant type="positive">Active</nx-badge>
                        </td>
                        <ng-template #inActive>
                            <td nxTableCell>
                                <nx-badge vibrant type="critical">In Active</nx-badge>
                            </td>
                        </ng-template>
                        <!-- <td nxTableCell *ngIf="item.status == 'Active'">
                            <nx-switcher [checked]="true"></nx-switcher>
                        </td>
                        <td nxTableCell *ngIf="item.status == 'In Active'">
                            <nx-switcher [checked]="false"></nx-switcher>
                        </td> -->
                        <td nxTableCell>
                            <nx-icon name="edit" size="s" (click)="toggleModal()"></nx-icon>
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<ng-template #addPolicy *ngIf="policyModalOpen">
    <form name='addplan-form' [formGroup]="policyMasterForm">

        <div nxLayout="grid">
            <div nxRow rowJustify="start,around">
                <h1 class="modal-heading" nxHeadline="page">Add Policy</h1>

            </div>
            <hr>
            <div nxRow>
                <div nxCol="12,6" nxAlignSelf="center">
                    <nx-formfield label="Policy Name">
                        <input nxInput formControlName="planName" />
                        <nx-error nxFormfieldError>
                            <strong>Please note:</strong> this field is required!
                        </nx-error>
                    </nx-formfield>
                </div>
                <div nxCol="12,6" nxAlignSelf="center">
                    <nx-formfield label="Duration(Years)">
                        <input nxInput formControlName="durationOfPlan" />
                        <nx-error nxFormfieldError>
                            <strong>Please note:</strong> this field is required!
                        </nx-error>
                    </nx-formfield>
                </div>
            </div>
            <div nxRow>
                <div nxCol="12,6" nxAlignSelf="center">
                    <nx-formfield label="Amount">
                        <input nxInput formControlName="totalPrice" />
                        <nx-error nxFormfieldError>
                            <strong>Please note:</strong> this field is required!
                        </nx-error>
                    </nx-formfield>
                </div>
                <div nxCol="12,6" nxAlignSelf="center">
                    <nx-formfield label="AWP Risk Price">
                        <input nxInput formControlName="awpRiskPrice" />
                        <nx-error nxFormfieldError>
                            <strong>Please note:</strong> this field is required!
                        </nx-error>
                    </nx-formfield>
                </div>
                <div nxCol="12,6" nxAlignSelf="center">
                    <nx-formfield label="Marketing Fund">
                        <input nxInput formControlName="marketingFund" />
                        <nx-error nxFormfieldError>
                            <strong>Please note:</strong> this field is required!
                        </nx-error>
                    </nx-formfield>
                </div>
                <div nxCol="12,6" nxAlignSelf="center">
                    <nx-formfield label="Customer Engagement Fund">
                        <input nxInput formControlName="customerEngementFund" />
                        <nx-error nxFormfieldError>
                            <strong>Please note:</strong> this field is required!
                        </nx-error>
                    </nx-formfield>
                </div>
                <div nxCol="12,6" nxAlignSelf="center">
                    <nx-formfield label="Customer Engagement Fund">
                        <input nxInput formControlName="customerEngementFund" />
                        <nx-error nxFormfieldError>
                            <strong>Please note:</strong> this field is required!
                        </nx-error>
                    </nx-formfield>
                </div>
                <div nxCol="12,6" nxAlignSelf="center">
                    <nx-formfield label="Royality">
                        <input nxInput formControlName="royality" />
                        <nx-error nxFormfieldError>
                            <strong>Please note:</strong> this field is required!
                        </nx-error>
                    </nx-formfield>
                </div>
            </div>
            <div nxRow class="mtop5percent">
                <div nxCol="8" colOffset='2'>
                    <button (click)="toggleModal()" nxButton="primary" type="button">Submit</button>
                    <button nxModalClose="close" (click)="toggleModal()" nxButton="secondary"
                        type="button">Close</button>

                </div>
            </div>
        </div>
    </form>
</ng-template>